import { ModuleManager, SectionList } from "@module-system";

import MediaSwitcher from "./Components/MediaSwitcher.vue";
import locales from "./locales";
import { ClientJS } from "clientjs";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "MediaSwitcher",
  version: "1.0.0",
  register() {
    ModuleManager.addLocales(locales, "MediaSwitcher");

    ModuleManager.addViewModule({
      key: "media-switcher",
      section: SectionList.LocalButtons,
      ViewComponent: MediaSwitcher,
      Condition: (rtcId) => {
        const clientJs = new ClientJS();
        return !clientJs.isMobile();
      },
    });
  },
};

export default module;
